import { useHistory } from 'react-router';

export const withRouter = (Component) =>{
    const Wrapper = (props) =>{
        const history = useHistory();
        return <Component history={history} {...props}/>
    } 
    return Wrapper;
}